module.exports = __webpack_public_path__ + "img/25.658af1d4.jpg";